import { PropsWithChildren } from 'react';
import BootstrapAlert, { AlertProps as BootstrapAlertProps } from 'react-bootstrap/Alert';
import classNames from 'classnames';

import { StyledComponent } from 'types';

type AlertProps = BootstrapAlertProps & StyledComponent & PropsWithChildren;

export const Alert: React.FC<AlertProps> = ({ children, className, ...props }) => (
  <BootstrapAlert className={classNames('rounded-1 riforma-regular', className)} {...props}>
    {children}
  </BootstrapAlert>
);
